module.exports = "https://www.svtstatic.se/play/play7/_next/static/images/syntolkat_100x56-492843d5c841c1b444224f85fa049444.png";